@if (hasMap()) {
  <h2 class="text-2xl font-bold mb-5">Hitta till mottagningen</h2>

  <div class="text-base mb-2">
    Klicka på kartan för att få vägbeskrivning.
  </div>

  <div>
    @defer (on viewport) {
      <app-google-map-loader
        [id]="id()"
        [name]="name()"
        [urlPath]="urlPath()"
        [address]="address()"
        [caregiverUnitImages]="caregiverUnitImages()"
        [height]="14"
        [useStaticData]="true"
      ></app-google-map-loader>
    } @placeholder {
      <div class="w-100 h-40">Loading map</div>
    }
  </div>
}
